import { Button, Typography, Paper } from "@mui/material";
import React from "react";

const DoctorsPage = () => {
  return (
    <React.Fragment>
      <Paper sx={{ flexGrow: 1, maxWidth: 1200 }}>
        <Typography> this is the doctors page</Typography>
        <Button> switch to lab</Button>
      </Paper>
    </React.Fragment>
  );
};

export default DoctorsPage;
